import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import PricingTiers from "@/components/PricingTiers";

export default function Pricing() {
  return (
    <div className="min-h-screen">
      <header className="glass sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="text-sm text-[#8B9BB4] hover:text-[#F6F1E4] transition-colors">← Back home</Link>
        </div>
      </header>
      <section className="max-w-7xl mx-auto px-5 py-20">
        <p className="overline text-center">Pricing</p>
        <h1 className="font-display text-5xl font-bold text-center mt-2 mb-4">Plans for every stage</h1>
        <p className="text-center text-[#8B9BB4] max-w-2xl mx-auto mb-14">From solo freelancers to global enterprises. Upgrade anytime with secure Stripe checkout.</p>
        <PricingTiers />
      </section>
    </div>
  );
}
